module.exports = __webpack_public_path__ + "media/images/account/icon7-f8cf59457a96d22c8fde75061a11001b.svg";